import React from 'react';
import PropTypes from 'prop-types';
import { Slide, Snackbar } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { popMessage } from '../../store/actions/app.action';

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

const Notification = () => {
  const message = useSelector(({ app }) => app.messages[0]);
  const dispatch = useDispatch();

  const onClose = () => dispatch(popMessage());

  return (
    <Snackbar
      open={message !== undefined}
      message={message?.msg || ''}
      TransitionComponent={TransitionUp}
      autoHideDuration={message?.actionRequired ? undefined : 4000}
      onClose={onClose}
      action={message?.action}
    />
  );
};

Notification.propTypes = {};

export default Notification;
